import { appAppleStoreLink } from '@core/consts';
import { StyleProps } from '@styles';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

type Props = StyleProps;

export const AppStoreBtn: FC<Props> = ({ className }) => {
  return (
    <a href={appAppleStoreLink} className={className}>
      <StaticImage height={54} src="./assets/app-store-btn.png" alt="Get CircleOf at the App Store" />
    </a>
  );
};

export default AppStoreBtn;
